export default {options:{api:'feedback',version:1},children:[{model:'feedback/documentation',options:{key:'documentation',type:'value'}}]}